module.exports = __webpack_public_path__ + "img/D201704_3.ab5a8eac.jpg";